module.exports = __webpack_public_path__ + "static/media/tutorial_vi_0.6c477862.png";